import { BackgroundCheck } from "@wingspanhq/wingspan-api-sdk";

import { ContextItem, RequirementTableItemData } from "../../../../types";

// v1 fell back to the settings title; the v3 check carries no title, so the
// requirement's own name is the only source
export const getBackgroundChecksRequirementName = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  backgroundCheck: BackgroundCheck | undefined
): string => {
  return requirement.name || "--";
};
